import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { svcDropdownsFeatureSelector } from '../svc-dropdowns-feature.selector';
export interface ServiceGroupSubCategoriesState extends EntityState<any> {}

export const serviceGroupSubCategoriesAdapter: EntityAdapter<any> = createEntityAdapter<any>({
  selectId: (serviceGroupSubCategory: any) => serviceGroupSubCategory.id
});

export const initialState: any = serviceGroupSubCategoriesAdapter.getInitialState();

export const serviceGroupSubCategoriesSelector = createSelector(
  svcDropdownsFeatureSelector,
  (state: any) => state.serviceGroupSubCategories
);

export const { selectIds, selectEntities, selectAll, selectTotal } = serviceGroupSubCategoriesAdapter.getSelectors(
  serviceGroupSubCategoriesSelector
);
